import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '@futrli/localisation';

import { HelpMenuContent } from '../help-menu-content/help-menu-content';
import {
  TRACK_ASK_QUESTION,
  TRACK_HELP_CENTRE,
  trackHelpMenuEvent
} from '../../../../../../skeleton/src/help/components/help-tracker';
import { useHelpMenuContext } from '../../../../../../skeleton/src/help/HelpMenuContext/HelpMenuContext';

import * as styles from './help-menu.scss';

export const HelpMenu = () => {
  const anchorElRef = useRef<HTMLDivElement | null>(null);

  const { anchorElement, closeMenu, openMenu, setDefaultAnchorElement } = useHelpMenuContext();

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    openMenu(event.currentTarget);
  };

  const onHelpCentreClick = () => {
    trackHelpMenuEvent(TRACK_HELP_CENTRE);
    closeMenu();
  };

  const onIntercomMenuClick = () => {
    trackHelpMenuEvent(TRACK_ASK_QUESTION);
    closeMenu();
  };

  // Set the default anchor element in the context (used when openMenu(null) is called)
  useEffect(() => {
    if (anchorElRef.current) {
      setDefaultAnchorElement(anchorElRef.current);
    }
  }, [setDefaultAnchorElement]);

  return (
    <>
      <div
        onClick={handleOpenMenu}
        className={classNames(styles.menuButton, styles.menuButtonContainer)}
        ref={anchorElRef}
      >
        <div className={styles.menuButtonInner}>
          <span className={styles.menuLabel}>
            <FormattedMessage id="common.help" defaultMessage="Help" />
          </span>
        </div>
      </div>

      <HelpMenuContent
        anchorElement={anchorElement}
        onClose={closeMenu}
        onHelpCentreClick={onHelpCentreClick}
        onIntercomMenuClick={onIntercomMenuClick}
      />
    </>
  );
};
